const MTAllocate = () => {
  return (
    <div className="mt-step-placeholder">
      <h2>Allocate</h2>
      <p>Allocate step content will be implemented here.</p>
    </div>
  )
}

export default MTAllocate
